export default "__VITE_ASSET__BJ1d2COd__"